import React, { useState } from "react";
import { Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import styled, { css } from "styled-components";
import { green } from "../constants/colors";

// Shared style for input height based on nesting
const inputHeight = ({ nested }) => css`
  height: ${nested ? "35px" : "48px"} !important;
`;

// Styled component for regular input
const StyledInput = styled(Input)`
  border-radius: ${(props) =>
    props.mainSearch ? "5px 0px 0px 5px" : "5px"} !important;
  border: 1px solid rgba(0, 0, 0, 0.25);
  ${inputHeight};
  // background-color: #fbf7fb !important;
  background-color: #F5F5F5 !important;
  color: #5e5e5e !important;
  border: 1px solid #eee;
  &::placeholder {
    // color: #5e5e5e !important;
    font-weight:700;
  }
`;

// Styled component for password input
const StyledPasswordInput = styled(Input.Password)`
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  ${inputHeight};
  // background-color: #fbf7fb !important;
  background-color: #f3f3f3 !important;

  color: gray !important;
  border: 1px solid #eee;
  &::placeholder {
    color: gray;
  }

  .ant-input-password-icon {
    color: gray;
  }
`;

// CustomInput component for regular inputs
export const CustomInput = ({
  placeholder,
  style,
  type,
  nested,
  onClick,
  value,
  mainSearch,
  icon,
  ...rest
}) => {
  return (
    <StyledInput
      type={type}
      mainSearch={mainSearch}
      onClick={onClick}
      nested={nested}
      value={value}
      {...rest}
      style={{
        ...style,
      }}
      placeholder={placeholder}
      prefix={icon}
    />
  );
};

// CustomPasswordInput component for password inputs with visibility toggle
export const CustomPasswordInput = ({
  placeholder,
  style,
  nested,
  ...rest
}) => {
  return (
    <StyledPasswordInput
      nested={nested}
      {...rest}
      style={{
        ...style,
      }}
      placeholder={placeholder}
      iconRender={(visible) =>
        visible ? (
          <EyeTwoTone style={{ color: green, fontSize: "16px" }} />
        ) : (
          <EyeInvisibleOutlined style={{ color: green, fontSize: "16px" }} />
        )
      }
    />
  );
};
